import React from "react";
// import Hero from "./components/Hero";
// import About from "./components/About";
// import WhyCreators from "./components/WhyCreators";
// import WhoThisIsFor from "./components/WhoThisIsFor";
// import Expectations from "./components/Expectations";
// import AffiliatePartnerships from "./components/AffiliatePartnerships";
// import SampleScripts from "./components/SampleScripts";
import SampleVideos from "./components/SampleVideos";
// import SignupForm from "./components/SignupForm";
// import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      {/* <Hero /> */}
      {/* <About /> */}
      {/* <WhyCreators /> */}
      {/* <WhoThisIsFor /> */}
      {/* <Expectations /> */}
      {/* <AffiliatePartnerships /> */}
      {/* <SignupForm /> */}
      {/* <SampleScripts /> */}
      <SampleVideos />
      {/* <Footer /> */}
    </div>
  );
}

export default App;
